import React from "react";
import { APPROACH } from "../../data";
import { Reveal, Eyebrow, H2 } from "./Typo";

export default function Approach({ id = "how-it-works" }) {
  return (
    <section id={id} data-testid="approach-section" className="section-pad bg-[#172B38] text-[#F4F1E9] scroll-mt-16">
      <div className="container-hw">
        <div className="grid lg:grid-cols-12 gap-8">
          <Reveal className="lg:col-span-6">
            <Eyebrow light>How it works</Eyebrow>
            <H2 light className="mt-6">{APPROACH.heading}</H2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-4 lg:col-start-9 self-end">
            <p className="text-[1.05rem] leading-relaxed text-[#F4F1E9]/75">{APPROACH.sub}</p>
          </Reveal>
        </div>
        <ol className="mt-16 md:mt-24 grid lg:grid-cols-4 border-l lg:border-l-0 lg:border-t border-[#F4F1E9]/20">
          {APPROACH.steps.map((s, i) => (
            <Reveal as="li" key={s.title} delay={i * 0.08} data-testid={`step-${i}`} className="relative pl-8 lg:pl-0 lg:pr-10 pb-12 lg:pb-0 lg:pt-10">
              <span className="absolute -left-[5px] top-1.5 lg:left-0 lg:-top-[5px] w-[9px] h-[9px] bg-[#8CAFC0]" />
              <p className="font-heading text-[#8CAFC0] text-xl">0{i + 1}</p>
              <h3 className="font-heading text-[1.75rem] leading-tight mt-3">{s.title}</h3>
              <p className="mt-3 text-[0.97rem] leading-relaxed text-[#F4F1E9]/70">{s.text}</p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
